<div class="custom-select-container">
    <div class="custom-select-wrapper">
        <brand-form-select
            (brandSelectChange)="onCountryChange($event)"
            [customError]="customError()"
            [optionsObject]="options | async"
            [label]="label()"
            [class]="'custom-select'"
            [name]="name()"
            [errorIconImageUrl]="errorIconImageUrl()"
        >
        </brand-form-select>
    </div>
</div>
